import { TablePaginationConfig } from 'antd'
import { PaginationProps } from 'antd/lib'
import { useState } from 'react'

import { DEFAULT_PER_PAGE } from 'src/app-constants'

export const useTablePagination = (
  paginationProps?: PaginationProps
): TablePaginationConfig => {
  const [pageSize, setPageSize] = useState([1, DEFAULT_PER_PAGE])

  return {
    hideOnSinglePage: true,
    showSizeChanger: false,
    align: 'end',
    current: pageSize[0],
    pageSize: pageSize[1],
    onChange: (current: number, pageSize: number) => {
      setPageSize([current, pageSize])
    },
    ...paginationProps
  }
}
